import { render, staticRenderFns } from "./LgButtonAcoes.vue?vue&type=template&id=cbe9f082"
import script from "./LgButtonAcoes.vue?vue&type=script&lang=js"
export * from "./LgButtonAcoes.vue?vue&type=script&lang=js"
import style0 from "./LgButtonAcoes.vue?vue&type=style&index=0&id=cbe9f082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports